/**
 *
 * @param currentPath
 * @param linkPath
 * @returns '/pathname' | '/repub/pathname'
 *
 * @description
 * cx-web adds repub to baseUrl, it is expected that link paths are prefixed
 * with repub so in this case we remove the repub from the linkPath.
 * In cases where there is no repub in baseUrl we return the linkPath as is and this also covers US.
 */

export const getPathWithSingleRepub = (
	currentPath: string,
	linkPath: string,
) => {
	const currentPathFirstSegment = currentPath.split('/')[1];
	const linkPathSegments = linkPath.split('/');

	if (currentPathFirstSegment === linkPathSegments[1]) {
		return `/${linkPathSegments.slice(2).join('/')}`;
	}

	return linkPath;
};
